import { Heading, PlusIcon, Text, TrendUpIcon } from '@weave/design-system';
import { InfoCard } from '../InfoCard/InfoCard';
import { childStyles } from './styles';
import { theme } from '@weave/theme';

type InsurancePayerMixRecommendedGainProps = {
  recommendedGainPercentage: number;
};

export const InsurancePayerMixRecommendedGain = ({
  recommendedGainPercentage,
}: InsurancePayerMixRecommendedGainProps) => {
  if (!recommendedGainPercentage) return null;

  return (
    <InfoCard title="Recommended Gain">
      <div css={childStyles}>
        <PlusIcon size={30} color="success" />
        <Heading level={2} css={{ margin: 0, color: theme.colors.success30 }}>
          {recommendedGainPercentage ? `${recommendedGainPercentage}%` : '-'}
        </Heading>
        <TrendUpIcon size={30} color="success" />
      </div>
    </InfoCard>
  );
};
